import type { SHARE_CARD_DETAILS_FORM_TYPE } from '../../modals/ShareViaEmailModal/consts';

const DEFAULT_MESSAGE_TEMPLATE_BY_SELECTION = {
  profile: `Hi,

To help me better tailor your upcoming travels, please fill out the information in this form. The more details you can share (such as frequent flyer numbers, bedding preferences, or dietary needs), the better I can personalize your future trips.
Thank you in advance for completing this form - I look forward to planning something wonderful for you.
If you have any questions, feel free to reach out to me anytime.

Best,`,
  credit_card: `Hi,

To proceed with your upcoming booking, please securely submit your credit card details using this form.
Thank you in advance for completing this form so I can finalize the arrangements for you.
If you have any questions, feel free to contact me anytime.

Best,`,
  both: `Hi,

To help me personalize your upcoming travels and complete your booking, please fill out the information requested in this form, including your profile details and payment information.
Thank you in advance for completing this form — this will help me take care of everything for your trip.
If you have any questions, feel free to reach out anytime.

Best,`,
} as const;

export const getDefaultMessageTemplateByForms = (selectedForms: SHARE_CARD_DETAILS_FORM_TYPE[]) => {
  const hasProfile = selectedForms.includes('profile');
  const hasCreditCard = selectedForms.includes('credit_card');

  if (hasProfile && hasCreditCard) return DEFAULT_MESSAGE_TEMPLATE_BY_SELECTION.both;
  if (hasProfile) return DEFAULT_MESSAGE_TEMPLATE_BY_SELECTION.profile;
  if (hasCreditCard) return DEFAULT_MESSAGE_TEMPLATE_BY_SELECTION.credit_card;

  return '';
};

type ResolveMessageForSelectionParams = {
  message: string;
  previousForms: SHARE_CARD_DETAILS_FORM_TYPE[];
  nextForms: SHARE_CARD_DETAILS_FORM_TYPE[];
};

export const resolveMessageForSelection = ({ message, previousForms, nextForms }: ResolveMessageForSelectionParams) => {
  const isMessageUntouched = message === '' || message === getDefaultMessageTemplateByForms(previousForms);

  return isMessageUntouched ? getDefaultMessageTemplateByForms(nextForms) : message;
};
